const config = {
  platforms: {
    SA: {
      UI_URL: "https://sa.reiformslive.com.au",
      API_URL: "https://sa.api.reiformslive.com.au",
      declineEnabled: true,
    },
    FLSA: {
      UI_URL: "https://sa.formslive.com.au",
      API_URL: "https://sa.api.formslive.com.au",
      declineEnabled: true,
      checklistEnabled: true,

      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    AICSA: {
      UI_URL: "https://sa.aicformslive.com.au",
      API_URL: "https://sa.api.aicformslive.com.au",
      declineEnabled: true,
      checklistEnabled: true,

      theme: {
        icon: "aic-icon.png",
        logo: "aic-logo-white.png",
        "Theme-Color-Navbar": "#2d2f84",
        "Theme-Color-Primary": "#4fa59c",
        "Theme-Button-Primary": "#2d2f84",
      },
    },
    NSW: {
      UI_URL: "https://nsw.reiformslive.com.au",
      API_URL: "https://nsw.api.reiformslive.com.au",
      declineEnabled: true,
      checklistEnabled: true,
    },
    NT: {
      UI_URL: "https://nt.reiformslive.com.au",
      API_URL: "https://nt.api.reiformslive.com.au",
      declineEnabled: true,
    },
    TAS: {
      UI_URL: "https://tas.formslive.com.au",
      API_URL: "https://tas.api.formslive.com.au",
      declineEnabled: true,
      checklistEnabled: true,

      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    ACT: {
      checklistEnabled: true,
      UI_URL: "https://act.formslive.com.au",
      API_URL: "https://act.api.formslive.com.au",
    },
    NT: {
      checklistEnabled: true,
      UI_URL: "https://nt.reiformslive.com.au",
      API_URL: "https://nt.api.reiformslive.com.au",
    },
    VIC: {
      declineEnabled: true,
      checklistEnabled: true,
      UI_URL: "https://vic.formslive.com.au",
      API_URL: "https://vic.api.formslive.com.au",
      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    QLD: {
      declineEnabled: true,
      checklistEnabled: true,
      UI_URL: "https://qld.formslive.com.au",
      API_URL: "https://qld.api.formslive.com.au",
      theme: {
        icon: "fl-icon-inverted.png",
        logo: "fl-logo.png",
        "Theme-Color-Primary": "#4884ee",
        "Theme-Button-Primary": "#4884ee",
      },
    },
    WA: {
      declineEnabled: true,
      checklistEnabled: true,
      UI_URL: "https://wa.reiformslive.com.au",
      API_URL: "https://wa.api.reiformslive.com.au",
    },
  },
  livesign: {
    scriptId: "__livesign_widget",
    url: "https://widget.verify.live-sign.com",
  },
};

export default config;
